import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';

export const CATALOG_ENTITIES = { TOPICS:'topics', BLOCKS:'blocks', SUBJECTS:'subjects', MODULES:'modules', LESSONS:'lessons', QUESTIONS:'questions', FLASHCARDS:'flashcards', MIND_MAPS:'mindMaps', QUICK_REVIEWS:'quickReviews', MATERIALS:'materials', MUSIC:'music', EXAM_TEMPLATES:'examTemplates' };
export async function loadAuthorizedCatalog(courseIds, admin = false) {
  if(admin){const courses=await getDocs(collection(db,'courses'));courseIds=courses.docs.map(d=>d.id);}
  const catalog = { COURSES:[], ...Object.fromEntries(Object.keys(CATALOG_ENTITIES).map(key => [key, []])), legacyCards:[], legacyQuestions:[],legacyPhrases:[] };
  await Promise.all(courseIds.map(async courseId => {
    const course = await getDoc(doc(db, 'courses', courseId));
    if (course.exists() && (admin || course.data().ativo !== false)) catalog.COURSES.push({ ...course.data(), id:course.id });
    await Promise.all(Object.entries(CATALOG_ENTITIES).map(async ([key, name]) => {
      const filters = [where('courseId', '==', courseId)];
      if (!admin) filters.push(where('published', '==', true));
      const snap = await getDocs(query(collection(db, name), ...filters));
      catalog[key].push(...snap.docs.map(item => ({ ...item.data(), id:item.id })));
    }));
    if (courseId === 'pcba-investigador') {
      const snap = await getDocs(query(collection(db, 'legacyStudyBundles'), where('courseId','==',courseId), where('published','==',true)));
      for (const item of snap.docs) {
        const data=item.data();
        if (data.kind === 'cards') catalog.legacyCards.push(...data.items);
        if (data.kind === 'questions') catalog.legacyQuestions.push(...data.items);
        if (data.kind === 'phrases') catalog.legacyPhrases.push(...data.items);
      }
    }
  }));
  catalog.COURSES.sort((a,b) => a.ordem-b.ordem);
  return catalog;
}
